export default __webpack_public_path__ + "static/media/css3.7e3f1784.svg";